import { render } from "./SalirView.vue?vue&type=template&id=6c6c41ea&scoped=true"
import script from "./SalirView.vue?vue&type=script&lang=js"
export * from "./SalirView.vue?vue&type=script&lang=js"

import "./SalirView.vue?vue&type=style&index=0&id=6c6c41ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6c41ea"]])

export default __exports__